import { Module } from 'vuex';
import { RootState } from 'frontend/types';
import { LearningPathRecommendation, LevelCourse } from 'frontend/types/learningPathV2';

interface NuxRecommendations {
  learning_paths?: LearningPathRecommendation[];
  electives?: LevelCourse[];
}

const nuxRecommendations: Module<NuxRecommendations, RootState> = {
  namespaced: true,
  state: {
    learning_paths: undefined,
    electives: undefined,
  },
  getters: {
    learningPaths: state => state.learning_paths,
    electives: state => state.electives,
  },
  mutations: {
    setValue(state: NuxRecommendations, value: NuxRecommendations): void {
      Object.assign(state, value);
    },
  },
};

export default nuxRecommendations;
